import { AuxBadge } from "@blk/aladdin-react-components-es";
import { AuxBadgeTypeEnum, AuxBadgeStyleEnum } from "@blk/aladdin-web-components";
import React from "react";
import styles from "./insUNGlobalCompactPrinciplesWidget.module.scss";
import { language } from "language/default";
const principlesWidgetLang = language.en.widgets.principlesTable;
export const InsPrinciplesFooter = () => React.createElement("div", { className: styles.footerRight },
    React.createElement(AuxBadge, { className: styles.icon, type: AuxBadgeTypeEnum.ICON, badgeStyle: AuxBadgeStyleEnum.ALERT }),
    React.createElement("div", null, principlesWidgetLang.violation),
    React.createElement(AuxBadge, { className: styles.icon, type: AuxBadgeTypeEnum.ICON, badgeStyle: AuxBadgeStyleEnum.WARNING }),
    React.createElement("div", null, principlesWidgetLang.potentialViolation),
    React.createElement(AuxBadge, { className: styles.icon, type: AuxBadgeTypeEnum.ICON, badgeStyle: AuxBadgeStyleEnum.SUCCESS }),
    React.createElement("div", null, principlesWidgetLang.noViolation));
